import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import TopNav from "../components/TopNav";
import { api } from "../lib/api";
import { formatPrice } from "../lib/cart";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const order = params.get("order");
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!order) {
        setLoading(false);
        return;
      }
      try {
        const response = await api.get(`/orders/${order}`);
        setOrderDetails(response.data);
      } catch (error) {
        console.error("Failed to fetch order details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [order]);

  return (
    <>
      <TopNav />
      <div className="aa-shell aa-center" style={{paddingTop: "100px"}}>
        <div className="aa-eyebrow">Order confirmed</div>
        <h1 className="aa-h1">Thank you for your order</h1>
        <p className="aa-sub" style={{marginInline:"auto"}}>
          We've sent your order confirmation and an account-setup link to your email. Click the link in that email to set your password and access your dashboard.
        </p>
        {order && <p className="aa-caption" data-testid="order-id">Order #{order}</p>}

        {!loading && orderDetails && (
          <div style={{maxWidth: "600px", margin: "30px auto", textAlign: "left"}}>
            <hr className="aa-hr"/>
            <h2 className="aa-h2" style={{fontSize:"1.3rem", marginBottom: "20px"}}>Invoice Details</h2>

            {orderDetails.items && orderDetails.items.length > 0 && (
              <div style={{marginBottom: "20px"}}>
                <h3 className="aa-label" style={{marginBottom: "12px"}}>Items</h3>
                {orderDetails.items.map((item, idx) => (
                  <div key={idx} style={{display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom: "1px solid rgba(193,127,58,.15)"}}>
                    <div>
                      <div style={{fontWeight: 600}}>{item.name}</div>
                      <div className="aa-card-sub">Qty: {item.qty}</div>
                    </div>
                    <div style={{fontFamily:"var(--font-display)", color:"var(--gold)"}}>
                      {formatPrice(item.price_cents * item.qty)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {orderDetails.shipping_address && (
              <div style={{marginBottom: "20px"}}>
                <h3 className="aa-label" style={{marginBottom: "8px"}}>Shipping Address</h3>
                <p style={{color: "var(--white)", lineHeight: 1.6}}>
                  {orderDetails.shipping_address}
                </p>
              </div>
            )}

            {orderDetails.payment_method && (
              <div style={{marginBottom: "20px"}}>
                <h3 className="aa-label" style={{marginBottom: "8px"}}>Payment Method</h3>
                <p style={{color: "var(--white)"}}>
                  {orderDetails.payment_method}
                </p>
              </div>
            )}

            <hr className="aa-hr"/>
            <div style={{display:"flex", justifyContent:"space-between", padding:"8px 0", fontSize:"1rem"}}>
              <span>Subtotal</span>
              <span>{orderDetails.subtotal_amount ? formatPrice(orderDetails.subtotal_amount) : formatPrice(orderDetails.total_amount)}</span>
            </div>
            {orderDetails.tax_amount > 0 && (
              <div style={{display:"flex", justifyContent:"space-between", padding:"8px 0", fontSize:"1rem", color:"var(--muted)"}}>
                <span>Tax</span>
                <span>{formatPrice(orderDetails.tax_amount)}</span>
              </div>
            )}
            <hr className="aa-hr" style={{margin:"12px 0"}}/>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
              <span className="aa-label">TOTAL</span>
              <span style={{fontFamily:"var(--font-display)", fontSize:"2rem", color:"var(--gold)"}} data-testid="order-total">
                {orderDetails.total_amount ? formatPrice(orderDetails.total_amount) : "$0.00"}
              </span>
            </div>
          </div>
        )}

        <div className="aa-bottom" style={{justifyContent:"center"}}>
          <Link to="/" className="aa-btn-ghost" data-testid="success-home">Back home</Link>
        </div>
      </div>
    </>
  );
}
